import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Reativar usuário/a ")
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "flex md6" }
const _hoisted_4 = { class: "flex md6" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "flex md6" }
const _hoisted_7 = { class: "flex md6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "flex md6" }
const _hoisted_10 = { class: "flex md6" }
const _hoisted_11 = { class: "mdo-select" }
const _hoisted_12 = { for: "roles" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "row" }
const _hoisted_15 = {
  key: 0,
  class: "flex md6"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "flex"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Reativar usuário/a ")
const _hoisted_19 = {
  key: 1,
  class: "flex"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Desativar usuário/a ")

import {
  Account,
  RoleEnum,
  UserCreateInput,
  UserRequiredActionEnum,
  UserResponse,
  UserUpdateInput
} from "@/codes/gen/types";
import {ReactiveData} from "@/codes/types/MDOTypes";
import {onMounted, reactive, ref, toRaw} from "vue";
import {ROUTE_NAMES} from "@/codes/util/constants";
import {useI18n} from "vue-i18n";
import {AccountService} from "@/codes/services/AccountService";
import {UserService} from "@/codes/services/UserService";
import router from "@/router";
import Swal from "sweetalert2";
import {useRoute} from "vue-router";
import {useForm} from "vee-validate";
import {Confirm} from "@/codes/util/swalUtil";
import AccountsSelect from "../../components/mdo/AccountsSelect.vue"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const user = reactive<ReactiveData<UserCreateInput>>({ data: {} as UserCreateInput });
const accounts = reactive<ReactiveData<Account[]>>({ data: [] as Account[] });
const accountsLoading = ref(false);
const accountsListSelection = reactive<ReactiveData<Account[]>>({ data: [] as Account[] });
const confirmPassword = ref('');
const userService = new UserService();
const accountService = new AccountService();

const i18n = useI18n();

const roles = reactive({ data: [] as any });
for (const a of Object.values(RoleEnum)) {
  const t = i18n.t(`enums.${a}`);
  roles.data.push({ text: t, value: a });
}

const isEdit = ref(false);

const confirm = function(value: string) {
  const needsValidation = (isEdit.value && user.data.password && user.data.password.length > 0) || !isEdit.value;
  if (needsValidation) {
    if (user.data.password === value) {
      return true;
    }

    return i18n.t('error.confirmPasswordNotMatch');
  } else {
    return true;
  }
}
const enableRequireAccountField = function (){
  return !(user.data.roles?.includes(RoleEnum.Webmaster) || user.data.roles?.includes(RoleEnum.Consultant))
}

const changeListAccounts = function (ev){
  accountsListSelection.data = toRaw(ev) || []
}


const enableListAccountField = function (){
  return user.data.roles?.includes(RoleEnum.Consultant) && !user.data.roles?.includes(RoleEnum.Webmaster)
}


let idUserEdit = '';

const form = useForm();
const formMeta = reactive(form.meta);

// const requiredActions = reactive({ data: [] as any });
// for (const a of Object.values(UserRequiredActionEnum)) {
//   const t = i18n.t(`enums.${a}`);
//   requiredActions.data.push({ text: t, value: a });
// }

const loadAccounts = async function() {

  accountsLoading.value = true;
  try {
    const result = await accountService.getOptions();
    if (result) {
      accounts.data = result.edges;
    }
  } finally {
    accountsLoading.value = false;
  }
}

const loadUser = async function(id: string) {

  const result = await userService.get(id);
  if (result) {
    const uc: UserCreateInput = {
      id: result.id,
      name: result.name,
      username: result.username,
      account: result.account?.id,
      email: result.email,
      requiredAction: result.requiredAction ?? UserRequiredActionEnum.None,
      roles: result.roles,
      password: '',
      accountList: result.accountList?.map(acc => acc.id),
      deletedAt: result.deletedAt?.transform? {
        transform: result.deletedAt?.transform
      } : null
    }
    user.data = uc;
    form.setValues(uc);
  }
}

onMounted(() => {
  loadAccounts();

  const route = useRoute();

  if (route && route.name === ROUTE_NAMES.editUser) {
    idUserEdit = route.params.id as string;
    loadUser(idUserEdit);
    isEdit.value = true;
  }
})

const save = async function() {
  const validate = await form.validate() as any;
  if (validate.valid) {
    const funcConcluir = (result: UserResponse | null | undefined) => {
      if (result && result.data.id) {
        idUserEdit = '';
        router.push({ name: ROUTE_NAMES.users });
      } else {
        Swal.fire({
          title: i18n.t('genericErrorTitle'),
          text: i18n.t('saveErrorMessage', { register: i18n.t('user.title'), message: result?.message })
        });
      }
    }
    if (isEdit.value) {
      const userUpdate: UserUpdateInput = {
        name: user.data.name,
        account: user.data.account,
        email: user.data.email,
        requiredAction: UserRequiredActionEnum.None,
        roles: user.data.roles,
        username: user.data.username
      };

      if (user.data.password) {
        userUpdate.password = user.data.password;
      }

      if(enableListAccountField()){
         userUpdate.accountList = accountsListSelection.data ? accountsListSelection.data.map(account => account.id) : null;
      }
      const result = await userService.update(idUserEdit, userUpdate);
      funcConcluir(result);
    } else {
      const createData = {...user.data, requiredAction: UserRequiredActionEnum.None}

      if(enableListAccountField()){
        createData.accountList = accountsListSelection.data ? accountsListSelection.data.map(account => account.id) : null;
      }
      const result = await userService.save(createData);
      funcConcluir(result);
    }
  }
}

function cancel() {
  if (form.meta.value.dirty) {
    Confirm.fire({
      title: i18n.t('form.confirmCancelTitle'),
      text: i18n.t('form.confirmCancelText')
    })
    .then((result) => {
      if (result.isConfirmed) {
        router.push({ name: ROUTE_NAMES.users });
      }
    });
  } else {
    router.push({ name: ROUTE_NAMES.users });
  }
}

const doRestore = async function() {
  const result = await userService.restore(user.data.id);
  if (result && result.data) {
    loadUser(user.data.id);
  }
}
function restore() {
  Confirm.fire({
    title: "Reativar usuário/a",
    text: `Deseja realmente reativar o/a usuário/a ${user.data?.name}`
  })
      .then((result) => {
        if (result.isConfirmed) {
          doRestore();
        }
      })
}
const doRemove = async function() {
  const result = await userService.remove(user.data.id);
  if (result && result.data) {
    loadUser(user.data.id);
  }
}
function remove() {
  if(!user.data.id){
    return;
  }

  Confirm.fire({
    title: "Desativar usuário/a",
    text: `Deseja realmente desativar o/a usuário/a ${user.username}`
  })
      .then((result) => {
        if (result.isConfirmed) {
          doRemove();
        }
      })
}


return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_alert = _resolveComponent("va-alert")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_VField = _resolveComponent("VField")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_base_form = _resolveComponent("base-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_form, {
      "form-meta": _unref(formMeta),
      onSave: save,
      onCancel: cancel
    }, {
      actions: _withCtx(() => [
        (_unref(user).data.deletedAt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_va_button, {
                icon: "fas fa-repeat",
                color: "info",
                size: "medium",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (restore()))
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (!_unref(user).data.deletedAt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_va_button, {
                icon: "fas fa-trash",
                color: "warning",
                size: "medium",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (remove()))
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (_unref(user).data.deletedAt)
          ? (_openBlock(), _createBlock(_component_va_alert, {
              key: 0,
              color: "warning",
              closeable: "",
              title: "USUÁRIO INATIVO/A",
              icon: "warning",
              center: "",
              class: "mb-6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, "Esta usuário/a foi desativada em " + _toDisplayString(_unref(user).data.deletedAt.transform) + ". Você pode ativar este usuário/a para voltar a utilizá-lo/a.", 1),
                _createVNode(_component_va_button, {
                  icon: "fas fa-repeat",
                  color: "info",
                  size: "medium",
                  class: "mt-4 mb-2",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (restore()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_VField, {
              name: "name",
              rules: "required|min:6"
            }, {
              default: _withCtx(({ field, errors: nameErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(user).data.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(user).data.name = $event)),
                  class: "mb-4",
                  label: _ctx.$t('register.name'),
                  error: nameErrors && nameErrors.length > 0,
                  "error-messages": nameErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_VField, {
              name: "username",
              rules: "required|min:6"
            }, {
              default: _withCtx(({ field, errors: usernameError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(user).data.username,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(user).data.username = $event)),
                  class: "mb-4",
                  label: _ctx.$t('users.username'),
                  error: usernameError && usernameError.length > 0,
                  "error-messages": usernameError
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_VField, {
              name: "password",
              rules: { required : !isEdit.value, min:6 }
            }, {
              default: _withCtx(({ field, errors: passwordError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(user).data.password,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(user).data.password = $event)),
                  type: "password",
                  class: "mb-4",
                  label: _ctx.$t('auth.password'),
                  error: passwordError && passwordError.length > 0,
                  "error-messages": passwordError
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            }, 8, ["rules"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_VField, {
              name: "confirmPassword",
              rules: confirm
            }, {
              default: _withCtx(({ field, errors: confirmPasswordError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: confirmPassword.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (confirmPassword.value = $event)),
                  type: "password",
                  class: "mb-4",
                  label: _ctx.$t('users.confirmPassword'),
                  error: confirmPasswordError && confirmPasswordError.length > 0,
                  "error-messages": confirmPasswordError
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_VField, {
              name: "email",
              rules: "required|email"
            }, {
              default: _withCtx(({ field, errors: emailError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(user).data.email,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_unref(user).data.email = $event)),
                  class: "mb-4",
                  label: _ctx.$t('register.email'),
                  error: emailError && emailError.length > 0,
                  "error-messages": emailError
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('users.role')), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_unref(user).data.roles = $event)),
                name: "roles",
                multiple: ""
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(roles).data, (op) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: op.value,
                    value: op.value
                  }, _toDisplayString(op.text), 9, _hoisted_13))
                }), 128))
              ], 512), [
                [_vModelSelect, _unref(user).data.roles]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (enableRequireAccountField())
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_va_select, {
                  modelValue: _unref(user).data.account,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_unref(user).data.account = $event)),
                  class: "mb-4",
                  label: _ctx.$t('users.account'),
                  options: _unref(accounts).data,
                  "text-by": "name",
                  "value-by": "id",
                  "track-by": "id",
                  searchable: "",
                  "no-options-text": _ctx.$t('users.accountNotFound'),
                  loading: accountsLoading.value
                }, null, 8, ["modelValue", "label", "options", "no-options-text", "loading"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (enableListAccountField())
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(AccountsSelect, {
                accounts: _unref(accounts).data,
                "default-selected": _unref(user).data.accountList || [],
                onChangeselected: changeListAccounts
              }, null, 8, ["accounts", "default-selected"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["form-meta"])
  ]))
}
}

})